import Canvas from './Canvas';
import React from 'react';
import update from 'immutability-helper';

class RandomSmoothCanvas extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            canvasData: {
                background: '#FFFFFF',
                pen: {
                    paths: [
                        {
                            color: props.color,
                            points: []
                        }
                    ],
                },
                marker: {
                    paths: []
                },
                existing: [],
            },
            x: Math.random(),
            y: Math.random(),
            vx: Math.random() * 0.05 - 0.025,
            vy: Math.random() * 0.05 - 0.025,
            ax: 0,
            ay: 0,
        };
    }

    componentDidMount() {
        this.timerID = setInterval(() => this.addRandom(), this.props.updateInterval);
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    addRandom() {
        if (this.state.canvasData.pen.paths[this.state.canvasData.pen.paths.length - 1].points.length > 2000) {
            this.setState((state, props) => {
                return {
                    canvasData: update(state.canvasData, {
                        pen: {
                            paths: {
                                $push: [{
                                    color: props.color,
                                    points: []
                                }]
                            }
                        }
                    })
                };
            })
        }
        this.setState((state, props) => {
            var ax = Math.random() * 0.02 - 0.01;
            var ay = Math.random() * 0.02 - 0.01;
            if (state.x > 0.9) {
                ax = -0.01
            } else if (state.x < 0.1) {
                ax = 0.01
            }
            if (state.y > 0.9) {
                ay = -0.01
            } else if (state.y < 0.1) {
                ay = 0.01
            }

            return {
                canvasData: update(state.canvasData, {
                    pen: {
                        paths: {
                            [state.canvasData.pen.paths.length - 1]: {
                                points: {
                                    $push: [{
                                        x: state.x,
                                        y: state.y
                                    }]
                                },
                            },
                        },
                    },
                }),
                x: state.x + state.vx * 0.3,
                y: state.y + state.vy * 0.3,
                vx: Math.max(-0.05, Math.min(0.05, state.vx + state.ax)),
                vy: Math.max(-0.05, Math.min(0.05, state.vy + state.ay)),
                ax: ax,
                ay: ay
            }
        });
    }

    render() {
        return (
            <Canvas data={this.state.canvasData} width={this.props.width} hideCursor={false} drawingStrategy={this.props.drawingStrategy} />
        );
    }
}

export default RandomSmoothCanvas;
